import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import '../user/User.css';
import {notification} from "antd";
import LoadingIndicator from "../../common/LoadingIndicator";
import {API_BASE_URL} from "../../constants";

class IncomeDeleteModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            isLoading:false,

        };
        this.handleDelete = this.handleDelete.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleLogout=this.handleLogout.bind(this);
    }

    handleDelete(id) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/financial-transaction/" + id,
            method: "delete",
        };
        request(params)
            .then(() => {
                self.setState({alert: null});
            }).catch(function (error) {
            showAxiosError(error);
        });
        notification.success({
            message: 'ŞanlıUrfa Eczacı Odası',
            description: "Gelir Silindi",
            duration:30,
        });
        this.cancelProcess();
    }



    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        console.log("selectedIncome", this.props.selectedIncome)
        return (
            <div className='oda-form-container'>
                {
                    (this.state.isLoading)&&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">{this.props.selectedIncome ? this.props.selectedIncome.transactionTitle : ""} Gelir Silinecektir</h4>

                </div>
                <div className="modal-footer">
                    <div className='col-sm-12 row'id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8" />
                        <div className='col-sm-2'>
                            <button type="button"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                // disabled={(this.props.selectedUserEmail===null) || this.state.isLoading }
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    onClick={() => this.handleDelete(this.props.selectedIncome.id)}
                            >
                                Onayla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default IncomeDeleteModal;


// WEBPACK FOOTER //
// ./src/page/financial/IncomeDeleteModal.js